import { defineMessages } from 'react-intl';

const messages: {
	changeboardingTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	changeboardingText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	changeboardingTextAdvancedJQL: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	changeboardingOkButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	changeboardingTitle: {
		id: 'jira.nin.filter.refinement.filter-popup.changeboarding.title',
		defaultMessage: 'A new home for filters',
		description: 'Title for the first step of the filter refinement changeboarding',
	},
	changeboardingText: {
		id: 'jira.nin.filter.refinement.filter-popup.changeboarding.text',
		defaultMessage: 'Find work faster using filters.',
		description: 'Description the filter refinement changeboarding',
	},
	changeboardingTextAdvancedJQL: {
		id: 'jira.nin.filter.refinement.filter-popup.changeboarding.text.advanced.jql',
		defaultMessage: 'Select advanced or JQL mode to filter by more fields.',
		description: 'Description the filter refinement changeboarding',
	},
	changeboardingOkButton: {
		id: 'jira.nin.filter.refinement.filter-popup.changeboarding.ok',
		defaultMessage: 'OK',
		description: 'Label for OK button to close the spotlight',
	},
});

export default messages;
